/** Embla slide index for a category id in rendered (filtered) DOM order. */
export function categorySlideIndex(slideNodes: ArrayLike<Element>, categoryId: string): number {
    return Array.from(slideNodes).findIndex((node) => node.getAttribute('data-id') === categoryId);
}
